import { render } from "./UserDetailTemplate.vue?vue&type=template&id=b9ceb8aa&scoped=true&ts=true"
import script from "./UserDetailTemplate.vue?vue&type=script&lang=ts"
export * from "./UserDetailTemplate.vue?vue&type=script&lang=ts"

import "./UserDetailTemplate.vue?vue&type=style&index=0&id=b9ceb8aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ceb8aa"]])

export default __exports__